import React from 'react';
import { LoadingSkeleton } from '../shared/LoadingSkeleton';

export function BlogCardSkeleton() {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      {/* Image Skeleton */}
      <LoadingSkeleton className="h-48 w-full" />
      
      {/* Content Skeleton */}
      <div className="p-6">
        {/* Meta info */}
        <div className="flex items-center gap-4 mb-3">
          <LoadingSkeleton className="h-4 w-20" />
          <LoadingSkeleton className="h-4 w-16" />
          <LoadingSkeleton className="h-4 w-12" />
        </div>

        {/* Title */}
        <LoadingSkeleton className="h-6 w-full mb-2" />
        <LoadingSkeleton className="h-6 w-3/4 mb-3" />

        {/* Excerpt */}
        <LoadingSkeleton className="h-4 w-full mb-2" />
        <LoadingSkeleton className="h-4 w-full mb-2" />
        <LoadingSkeleton className="h-4 w-2/3 mb-4" />

        {/* Tags */}
        <div className="flex gap-2 mb-4">
          <LoadingSkeleton className="h-6 w-16 rounded-full" />
          <LoadingSkeleton className="h-6 w-20 rounded-full" />
          <LoadingSkeleton className="h-6 w-14 rounded-full" />
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <LoadingSkeleton className="h-4 w-24" />
          <LoadingSkeleton className="h-4 w-20" />
        </div>
      </div>
    </div>
  );
}